import { render, staticRenderFns } from "./PendingActionConfirm.vue?vue&type=template&id=680ec699&lang=pug"
import script from "./PendingActionConfirm.vue?vue&type=script&lang=ts"
export * from "./PendingActionConfirm.vue?vue&type=script&lang=ts"
import style0 from "./PendingActionConfirm.vue?vue&type=style&index=0&id=680ec699&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports